if (!customElements.get('video-toggle')) {
  class VideoToggle extends HTMLElement {
    constructor() {
      super();
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      this.pauseIcon = this.querySelector('.icon--pause');
      this.playIcon = this.querySelector('.icon--play');

      if (!this.video || !this.button) return;

      this.button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (this.video.paused) {
          this.video.play();
        } else {
          this.video.pause();
        }
      });

      this.video.addEventListener('play', () => this.setPlayingState(true));
      this.video.addEventListener('pause', () => this.setPlayingState(false));

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.video.autoplay = false;
        this.video.pause();
      }

      this.setPlayingState(!this.video.paused);
    }

    setPlayingState(playing) {
      const { labelPause, labelPlay } = this.button.dataset;

      this.button.setAttribute('aria-label', playing ? labelPause : labelPlay);
      this.pauseIcon?.classList.toggle('hidden', !playing);
      this.playIcon?.classList.toggle('hidden', playing);
    }
  }

  window.VideoToggle = VideoToggle;

  customElements.define('video-toggle', VideoToggle);
}
